import * as React from 'react'

import { NewUsername, validateUsernameV2 } from '@ally/forms'
import { BadWords } from '@ally/use-validation'

import { useTransmit } from '../../TransmitContext'

/**
 * This component is only required until the backend team supporting
 * guest user creation updates their logic to allow the same characters
 * as customer user creation. At that point, this component can be removed
 * and we can replace it with just the NewUsername component and utilize
 * it's default validation logic
 */

interface SharedNewUsernameProps {
  label?: string
  name?: string
}

export const SharedNewUsername: React.FC<SharedNewUsernameProps> = ({
  label = 'Username',
  name = 'username',
}) => {
  const { hostServices } = useTransmit()

  const badWords = hostServices?.hostData.badWords.data
  const badWordsObject: BadWords = badWords || {
    base: [],
    names: [],
    substring: [],
  }

  const sharedValidateUsername = (username: string): string | undefined => {
    let result = validateUsernameV2(username, badWordsObject)

    if (!result && !/^[a-zA-Z0-9_.]+$/.test(username)) {
      result = 'Enter a valid username.'
    }

    return result
  }

  return (
    <NewUsername
      label={label}
      name={name}
      badWords={badWordsObject}
      validate={sharedValidateUsername}
      contextualHelpContent=""
    />
  )
}
